/**
 * Контракт эндпоинта GET /v1/platform/me (Спринт 7 Этап 1).
 *
 * Бэкенд (internal/platform/me/service.go) отдаёт агрегат
 * { actor, tenant, modules } — единый источник навигации и роутинга роли.
 *
 * Generic SaaS: ничего mara-специфичного, всё приходит от бэкенда по slug.
 */
import { customFetch } from '@hsc/api-client';

/** Роли актора как их отдаёт бэкенд (claims.Roles). */
export type ActorRole =
  | 'guest'
  | 'staff'
  | 'hotel_manager'
  | 'manager'
  | 'tenant_owner'
  | 'owner'
  | 'front_desk'
  | 'housekeeper'
  | 'maintenance'
  | 'restaurant'
  | 'vendor_buyer'
  | 'vendor'
  | string;

export interface ActorView {
  id: string;
  name: string;
  roles: ActorRole[];
}

export interface TenantView {
  slug: string;
  brand: string;
}

/**
 * Один модуль платформы — основа динамической навигации.
 *  - `key`: машинный ключ модуля (stays, rooms, ...), маппится в label.
 *  - `icon`: имя Phosphor-иконки (отдаётся бэкендом).
 *  - `path`: роут модуля внутри SPA.
 *  - `services`: доступные действия/подразделы внутри модуля.
 */
export interface ModuleView {
  key: string;
  icon: string;
  path: string;
  services: string[];
}

export interface PlatformMeResponse {
  actor: ActorView;
  tenant: TenantView;
  modules: ModuleView[];
}

/** GET /v1/platform/me — агрегат текущего пользователя. */
export async function fetchPlatformMe(): Promise<PlatformMeResponse> {
  return customFetch<PlatformMeResponse>({
    url: '/platform/me',
    method: 'GET',
    // Явный baseURL: бэкенд монтирует под /v1 (nginx также проксирует /api/v1 → /v1).
    baseURL: '/v1',
  });
}
